import axios, { AxiosResponse } from "axios"
import { BloqueoContableAdapter } from "./BloqueoPeriodoContable.adapter"
import { UpdateBloqueoPeriodoContableCommandProps } from "./Commands/UpdateBloqueoPeriodoContableCommand"
import { GetBloqueoPeriodoContableDtoProps } from "./DTOs/GetBloqueoPeriodoContableDto"

export async function getBloqueoPeriodoContable(
  year: number
): Promise<GetBloqueoPeriodoContableDtoProps> {
  const { data }: { data: GetBloqueoPeriodoContableDtoProps } = await axios.get(
    `/BloqueoPeriodoContable/${year}`
  )
  return BloqueoContableAdapter(data)
}

export const putBloqueoPeriodoContable = async (
  blockedPeriods: UpdateBloqueoPeriodoContableCommandProps
): Promise<AxiosResponse> => {
  const response = await axios.put("/BloqueoPeriodoContable/", blockedPeriods)
  return response
}
